import { History, MemoryHistory, createBrowserHistory, createMemoryHistory } from 'history';
import { getEnvironment } from '@minecraft.environment';

let historySingleton: History | null = null;

/**
 * invoke this in the top level index.tsx for a package and pass the resulting history object
 * to the RouteProvider component that mounts the router context
 */
export const createHistory = (): History => {
  const environment = getEnvironment();
  const history = createBrowserHistory({ basename: environment.BASE_NAME });
  historySingleton = history;
  return history;
};

/** use this when creating a history instance for testing purposes, this is done automatically in
 * renderTest of the minecraft test harness, but for some unit tests and other basic implementations
 * you may want to do this manually
 */
export const createTestHistory = ({ initialRoute }: { initialRoute: string }): MemoryHistory => {
  // memory history does not support basenames so we won't apply it in tests
  const history = createMemoryHistory({ initialEntries: [initialRoute] });
  historySingleton = history;
  return history;
};

/**
 * @deprecated
 * this is used by code that does not have access to the router context
 * as of now this will be in authErrorLink & getRedirectQueryParams for legacy reasons
 *
 * we want to update those locations and pass the history object directly
 * either from the useRouter hook, or from the object returned by createHistory in index.tsx
 */
export const getHistory = (): History => {
  if (!historySingleton) {
    throw new Error('getHistory() called before RouteProvider was mounted');
  }
  return historySingleton;
};
